<div class="auth-card">
  <!-- Logo -->
  <div class="auth-logo">
    <img src="assets/images/NBHA-Norway.png" alt="NBHA Norway" />
  </div>

  <!-- Header -->
  <div class="auth-header">
    <h1>Reset your password</h1>
    <p>Enter your new password below</p>
  </div>

  <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
    <!-- Password Field -->
    <div class="form-group">
      <label for="password" class="form-label">New password</label>
      <div class="password-toggle">
        <input
          [type]="passwordVisible ? 'text' : 'password'"
          id="password"
          formControlName="password"
          class="form-control"
          [class.is-invalid]="resetForm.get('password')?.hasError('passwordStrength') && resetForm.get('password')?.touched"
          placeholder="Create a strong password"
          required
        />
        <i
          [class]="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
          class="password-toggle-icon"
          (click)="togglePasswordVisibility('password')"
        ></i>
      </div>
      <span *ngIf="resetForm.get('password')?.hasError('passwordStrength') && resetForm.get('password')?.touched" class="invalid-feedback">
        Password must be at least 8 characters with 1 number and 1 special character
      </span>
    </div>

    <!-- Confirm Password Field -->
    <div class="form-group">
      <label for="confirmPassword" class="form-label">Confirm password</label>
      <div class="password-toggle">
        <input
          [type]="confirmPasswordVisible ? 'text' : 'password'"
          id="confirmPassword"
          formControlName="confirmPassword"
          class="form-control"
          [class.is-invalid]="resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched"
          placeholder="Re-enter your password"
          required
        />
        <i
          [class]="confirmPasswordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
          class="password-toggle-icon"
          (click)="togglePasswordVisibility('confirmPassword')"
        ></i>
      </div>
      <span *ngIf="resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched" class="invalid-feedback">
        Passwords do not match
      </span>
    </div>

    <!-- Password Requirements -->
    <div class="password-requirements">
      <div class="password-requirements-title">Password must include:</div>
      <div class="password-requirement">
        <i class="fa fa-check-circle"></i>
        <span>At least 8 characters</span>
      </div>
      <div class="password-requirement">
        <i class="fa fa-check-circle"></i>
        <span>At least 1 number</span>
      </div>
      <div class="password-requirement">
        <i class="fa fa-check-circle"></i>
        <span>At least 1 special character</span>
      </div>
    </div>

    <!-- Reset Button -->
    <div class="form-group mt-4">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="resetForm.invalid || isSubmitting"
      >
        <span *ngIf="!isSubmitting">Reset password</span>
        <span *ngIf="isSubmitting">
          <i class="fa fa-spinner spinner me-2"></i>
          Resetting...
        </span>
      </button>
    </div>
  </form>

  <!-- Divider -->
  <div class="auth-divider">
    <span>or</span>
  </div>

  <!-- Back to Login -->
  <button
    type="button"
    class="btn btn-outline"
    routerLink="/auth/login"
  >
    <i class="fa fa-arrow-left me-2"></i>
    Back to login
  </button>
</div>
